export default class BasketCount {
  constructor($header) {
    this.$header = $header;
  }

  init() {
    if (!this.$header.length) {
      return;
    }

    this.$text = this.$header.find('.mc-header-basket-link__text');

    const checkStorage = () => {
      const stored = window.localStorage.getItem('cfg_basket_store');
      if (!stored) {
        this.$text.text('0');
        return;
      }

      try {
        const data = JSON.parse(stored);
        const basketSize = data?.state?.basketSize;

        if (basketSize !== undefined && basketSize !== null) {
          this.$text.text(basketSize);
        } else {
          this.$text.text('0');
        }
      } catch (error) {
        // Ignore invalid JSON
      }
    };

    checkStorage();
  }
}
